import { useEffect, useState } from "react";
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";
import ImportAsset from "./ImportAsset";
import { useDispatch } from "react-redux";

interface IProps {
    updateAttachments?: Function;
    accept?: string;
    link?: any;
    tooltipConent?: any;
    isAttachmentsRequired?: boolean,
    reasonAttachment?: any;
    multiple?: any,
    onFileUpload?: any,
    uploadBtnLoading?: boolean;
    error?: string;
    onRemove?: any;
    uploadBtnClick?: any,
    uploadedList?: any,
    list?: any,
    setList?: any
    maxSize?: any
    setError?: any,
    iAttachmentEditable?:any
}
const DEFAULT_ACCEPT = ".xlsx,.xls,.doc,.docx,.odt,.ods,.ppt,.pptx,.pdf,.htm,.html,.jpeg,.jpg,.jpe,.jif,.jfif,.jfi,.png,.gif,.webp,.tiff,.tif,.psd";

const ImportAssetContainer = ({ multiple,
    accept = DEFAULT_ACCEPT,
    onRemove,
    maxSize,
    iAttachmentEditable = true
  }: IProps) => {

    const dispatch = useDispatch();
    const [list, setList] = useState<any>([]);
    const [error, setError] = useState<any>([]);
  
    const isValidFormat = (file: File) => {
      const extension = file.name.split(".").at(-1) || "";
      return accept.split(",").includes(`.${extension.toLowerCase()}`);
    };
  
    useEffect(()=>{
        let value:any = []
        setList(value)
    },[])
   
    const setListExt = (file: File) => {
      if (isValidFormat(file)) {
        if (multiple) {
          setList((prev: any) => [...prev, file]);
        } else {
          setList([file]);
        }
      }
    };
  
    const onRemoveExt = (index: number) => {
      dispatch(RequisitionAction?.setIsChangesOccured(true))
      onRemove(index);
    };
  
    const handleDrop = (ev: React.DragEvent<HTMLInputElement>) => {
      ev.preventDefault();
  
      if (ev.dataTransfer.items) {
        [...ev.dataTransfer.items]
          .filter((item) => item.kind === "file")
          .forEach((item) => {
            const file = item.getAsFile();
            if (file) {
              setListExt(file);
            }
          });
      } else {
        [...ev.dataTransfer.files].forEach(setListExt);
      }
    };
  
    const isValidSize = (file: File) => {
      const size = file.size / (1024 * 1024);
      return size < maxSize
    }
  
    const onFileUpload = ({
      target: { files },
    }: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(RequisitionAction?.setIsChangesOccured(true))
      if (files?.length) {
        let attachment = [];
        [...files].forEach((i: any) => {
          setError("")
          const attachmentObj = list.find((item: any) => item.name === i.name);
          if (attachmentObj) {
            attachment.push(attachmentObj)
          }
        })
        let validFiles: any = [...files].filter((file: File) => isValidFormat(file));
        if (attachment?.length) {
          setError("Please Try to add Unique Files")
          validFiles = validFiles.filter((i: any) => !list.find((item: any) => item.name === i.name));
        }
        if (maxSize && validFiles.length) {
          validFiles = validFiles.filter((file: File) => isValidSize(file))
          if (!validFiles.length) {
            setError("File size should not exceed 5MB");
          }
        }
        if (validFiles.length) {
          if (multiple) {
            if (validFiles.length <= 5) {
              setList((prev: any) => [...prev, ...validFiles]);
            } else {
              setList((prev: any) => [...prev, ...validFiles]);
              setError("Please Upload files without exceeding maximum limit of 5 files");
            }
          } else {
            setList([validFiles[0]]);
          }
        }
      }
    };
  
    const onDragOver = (event: React.DragEvent<HTMLInputElement>) => {
      dispatch(RequisitionAction?.setIsChangesOccured(true))
      event.stopPropagation();
      event.preventDefault();
      if (event.dataTransfer) event.dataTransfer.dropEffect = "copy";
    };
  
      
    return(
        <ImportAsset
            onRemoveExt={onRemoveExt}
            handleDrop={handleDrop}
            onFileUpload={onFileUpload}
            onDragOver={onDragOver}
            error={error}
            accept={accept}
            list={list}
            iAttachmentEditable={iAttachmentEditable}
        />
    )
}

export default ImportAssetContainer;